// extracted by mini-css-extract-plugin
export default {"wrapper":"IVZS1","secondaryButton":"HkTZ2","primaryButton":"J9cNW"};